import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

const noop = () => {};

const withClickDrag = (ChildComponent, opts = {}) => {
    const touch = opts.touch || false;
    const resetOnSpecialKeys = opts.resetOnSpecialKeys || false;
    const getSpecificEventData = opts.getSpecificEventData || (() => ({}));
    const excludedClasses = opts.excludedClasses || [];

    const onDragStart = opts.onDragStart || noop;
    const onDragStop = opts.onDragStop || noop;
    const onDragMove = opts.onDragMove || noop;

    class ClickDrag extends Component {
        constructor(props) {
            super(props);

            this.state = {
                isMouseDown: false,
                isMoving: false,
                mouseDownPositionX: 0,
                mouseDownPositionY: 0,
                moveDeltaX: 0,
                moveDeltaY: 0,
            };

            this.wasUsingSpecialKeys = false;
        }

        componentDidMount = () => {
            const node = findDOMNode(this);

            if (node) node.addEventListener('mousedown', this.onMouseDown);
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);

            if (touch) {
                if (node) node.addEventListener('touchstart', this.onMouseDown, { passive: true });
                document.addEventListener('touchmove', this.onMouseMove);
                document.addEventListener('touchend', this.onMouseUp);
            }
        };

        componentWillUnmount = () => {
            const node = findDOMNode(this);

            if (node) node.removeEventListener('mousedown', this.onMouseDown);
            document.removeEventListener('mousemove', this.onMouseMove);
            document.removeEventListener('mouseup', this.onMouseUp);

            if (touch) {
                if (node) node.removeEventListener('touchstart', this.onMouseDown, { passive: true });
                document.removeEventListener('touchmove', this.onMouseMove);
                document.removeEventListener('touchend', this.onMouseUp);
            }
        };

        onMouseDown = (event) => {
            // only left mouse button
            if (touch || event.button === 0) {
                const pt = (event.changedTouches && event.changedTouches[0]) || event;

                const { target } = event;
                const { className } = target;
                if (className) {
                    const elements = excludedClasses
                        .map(name => document.querySelectorAll(`.${name}`))
                        .reduce((previous, current) => [...previous, ...current], []);

                    const isExcluded = elements
                        .reduce(
                            (previous, current) => current.contains(target) || previous,
                            false,
                        );

                    if (isExcluded) return;
                }

                this.setMousePosition(pt.clientX, pt.clientY);
                onDragStart(event);
            }
        };

        onMouseUp = (event) => {
            const { isMouseDown } = this.state;

            if (isMouseDown) {
                this.setState({
                    isMouseDown: false,
                    isMoving: false,
                });

                onDragStop(event);
            }
        };

        onMouseMove = (event) => {
            const { isMouseDown } = this.state;

            if (isMouseDown) {
                const pt = (event.changedTouches && event.changedTouches[0]) || event;

                const isUsingSpecialKeys = event.metaKey
                    || event.ctrlKey || event.shiftKey || event.altKey;
                if (resetOnSpecialKeys && this.wasUsingSpecialKeys !== isUsingSpecialKeys) {
                    this.wasUsingSpecialKeys = isUsingSpecialKeys;
                    this.setMousePosition(pt.clientX, pt.clientY);
                } else {
                    const { mouseDownPositionX, mouseDownPositionY } = this.state;

                    this.setState({
                        isMoving: true,
                        moveDeltaX: pt.clientX - mouseDownPositionX,
                        moveDeltaY: pt.clientY - mouseDownPositionY,
                        ...getSpecificEventData(event),
                    }, () => onDragMove(event, this.state));

                    this.setMousePosition(pt.clientX, pt.clientY);
                }
            }
        };

        setMousePosition = (x, y) => {
            this.setState({
                isMouseDown: true,
                isMoving: false,
                mouseDownPositionX: x,
                mouseDownPositionY: y,
                moveDeltaX: 0,
                moveDeltaY: 0,
            });
        };

        render() {
            return <ChildComponent {...this.props} dataDrag={this.state} />;
        }
    }

    return ClickDrag;
};

export default withClickDrag;
